import { render, staticRenderFns } from "./ShopPlatformWithdraw.vue?vue&type=template&id=1355a2d7&scoped=true"
import script from "./ShopPlatformWithdraw.vue?vue&type=script&lang=js"
export * from "./ShopPlatformWithdraw.vue?vue&type=script&lang=js"
import style0 from "./ShopPlatformWithdraw.vue?vue&type=style&index=0&id=1355a2d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1355a2d7",
  null
  
)

export default component.exports